import React from 'react'
import numbro from 'numbro'
import Metric from '../Metric'

const Distance = ({
  amountColor,
  format,
  fundraisingPage,
  icon,
  iconColor,
  iconSize,
  label,
  labelColor,
  offset,
  multiplier,
  numberStyle,
  uom
}) => {
  const finalMultiplier = multiplier || (uom === 'mi' ? 0.000621371 : 1000)
  const amount = fundraisingPage.fitnessDistanceTotal * finalMultiplier + (offset || 0)

  return (
    <Metric
      amount={numbro(amount).format(format || '0,0')}
      amountColor={amountColor}
      icon={icon}
      iconSize={iconSize || 'small'}
      labelColor={iconColor}
      numberStyle={numberStyle}
      label={label}
    />
  )
}

export default Distance
